import * as yup from 'yup';

import {
    propFieldTypes as injectionPropFieldTypes
} from "../../../../hooks/api/useInjectionProps"

import {
    fieldDataTypes as injectionFieldDataTypes,
    moduleTypes as injectionFieldModuleTypes
} from "../../../../hooks/api/useInjectionFields"

const defCustomInjectionFields = { ref: injectionFieldModuleTypes.branch.customer.ref, module: injectionFieldModuleTypes.branch.customer.module }

export const customInjectionFields = {
    marking: { submitKey: "customer_branch_marking", retrieveKey: "inf_br_cust_customer_branch_marking", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
    postcode: { submitKey: "postcode", retrieveKey: "inf_br_cust_postcode", fieldDataTypeId: injectionFieldDataTypes.text.id, ...defCustomInjectionFields },
    sourceMarkingRemId: { submitKey: "source_marking_remid", retrieveKey: "inf_br_cust_source_marking_remid", fieldDataTypeId: injectionFieldDataTypes.value.id, ...defCustomInjectionFields },
}

export const customInjectionPropsBk = {
    marking: {
        submitKey: "customer_branch_marking",
        retrieveKey: "inj_cust_br_customer_branch_marking",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    },

    postcode: {
        submitKey: "postcode",
        retrieveKey: "inj_cust_br_postcode",
        propFieldId: injectionPropFieldTypes.text.id,
        propFieldName: injectionPropFieldTypes.text.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    },

    // scheduler
    sourceMarkingRemId: {
        submitKey: "source_marking_remid",
        retrieveKey: "inj_cust_br_source_marking_remid",
        propFieldId: injectionPropFieldTypes.value.id,
        propFieldName: injectionPropFieldTypes.value.fieldName,
        propIsMultiple: 0,
        getValue: (val) => {
            return val
        }
    }
}

// temp override this
export const customInjectionProps = customInjectionFields

export const validationSchema = yup.object({
    branchName: yup
        .string()
        .required('Required'),
    branchCode: yup
        .string()
        .required('Required'),
    branchContact: yup
        .string()
        .required('Required'),
    branchEmail: yup
        .string()
        .required('Required'),
    type: yup
        .mixed()
        .oneOf(["branch", "branch_shipping", "shipping_address"])
        .required('Required'),
    address1: yup
        .string()
        .required('Required'),
    // address2: yup
    //     .string()
    //     .required('Required'),
    countryId: yup
        .string()
        .required('Required'),
    stateId: yup
        .string()
        .required('Required'),
    areaId: yup
        .string()
        .required('Required'),
    postcode: yup
        .string()
        .required('Required'),
    marking: yup
        .string()
        .required('Required'),
    // picName: yup
    //     .string()
    //     .required('Required'),  
    // picContact: yup
    //     .number()
    //     .typeError("Only number")
    //     .required('Required')
    //     .test(
    //         "is-positive",
    //         "Please enter a positive number",
    //         (value) => value >= 0 && 1 / value !== -Infinity),
    // picEmail: yup
    //     .string()
    //     .email('Enter a valid email')
    //     .required('Required'),
    isHQ: yup
        .bool()
        .required('Required'),
})

export const initialValues = {
    branchName: "",
    branchCode: "",
    branchContact: "",
    branchEmail: "",
    type: "",
    address1: "",
    address2: "",
    countryId: "",
    stateId: "",
    areaId: "",
    postcode: "",
    picName: "",
    picContact: "",
    picEmail: "",
    isHQ: false,
    status: true,
    marking: "",
    remark: "",
    userId: "",
    id: ""
}

export const retailTypes = [
    {
        id: "branch",
        display: "Outlet",
        default: false,
    },
    {
        id: "branch_shipping",
        display: "Outlet & Shipping Address",
        default: true,
    },
    {
        id: "shipping_address",
        display: "Shipping Address",
        default: false,
    }
]

export const branchDataTypes = [
    {
        id: "branch",
        display: "Branch",
        default: false,
    },
    {
        id: "branch_shipping",
        display: "Branch & Shipping Address",
        default: true,
    },
    {
        id: "shipping_address",
        display: "Shipping Address",
        default: false,
    }
]
